export type { LocalRepository } from './local.repo'
export { LocalStorageRepository } from './local-storage.repo'
